import { all, call, put, takeEvery } from 'redux-saga/effects'
import { t } from 'ttag'
import { addNotification } from '../../../common/notifications/NotificationActions'
import { INotification } from '../../../common/notifications/NotificationReducers'
import api from '../../../services/api.services'
import {
  GetCompanyRankingFiltered$Request,
  GetCompanyRankingFiltered$Response,
  ToggleCompanyExcludedFromRanking$Request,
} from '../../../services/api.types'
import { getCompanyRanking, getCompanyRankingSuccess, toggleCompanyExcludedFromRanking } from './CompanyRankingActions'
import { Action } from 'redux-actions'
import { log } from '../../../services/log'
import Bugsnag from '@bugsnag/js'
import { getErrorMsg } from '../../../common/helpers/translations'

function* sagaGetCompanyRanking(action: Action<GetCompanyRankingFiltered$Request>) {
  try {
    const { periodPercentage, companyRanking, companyIsExcludedFromRanking }: GetCompanyRankingFiltered$Response =
      yield call(api.activity.getCompanyRankingFiltered, action.payload)
    yield put({
      type: String(getCompanyRankingSuccess),
      payload: { periodPercentage, companyRanking, companyIsExcludedFromRanking },
    })
  } catch (e: any) {
    /*const getCompanyRankingErrorNotification: INotification = {
      type: 'warning',
      content: getErrorMsg('ranking load'),
    }
    yield put({ type: String(addNotification), payload: getCompanyRankingErrorNotification })*/
    /*Bugsnag.notify(new Error('getCompanyRankingError error'), function (event) {
      event.context = 'getCompanyRankingError'
      event.addMetadata('error', e)
    })*/
  }
}

function* sagaToggleCompanyExcludedFromRanking(
  action: Action<[ToggleCompanyExcludedFromRanking$Request, GetCompanyRankingFiltered$Request]>,
) {
  try {
    yield api.users.toggleCompanyExcludedFromRanking(action.payload[0])
    yield put({ type: String(getCompanyRanking), payload: action.payload[1] })
  } catch (e: any) {
    const toggleErrorNotification: INotification = {
      type: 'warning',
      content: getErrorMsg('ranking anonymize'),
    }
    yield put({ type: String(addNotification), payload: toggleErrorNotification })
  }
}

export function* companyRankingSagas() {
  yield all([
    takeEvery(String(getCompanyRanking), sagaGetCompanyRanking),
    takeEvery(String(toggleCompanyExcludedFromRanking), sagaToggleCompanyExcludedFromRanking),
  ])
}
